import { SvgIconType } from './svg.interface';

const Spin: SvgIconType = ({ width = 50, height = 50, className = '' }) => (
  <svg
    version="1.1"
    id="Spinner"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 52.8 52.8"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill="#FFFFFF"
        d="M26.44,5.44c-11.6,0-21,9.4-21,21s9.4,21,21,21s21-9.4,21-21S38.04,5.44,26.44,5.44z M26.44,39.44
		c-7.18,0-13-5.82-13-13s5.82-13,13-13s13,5.82,13,13S33.62,39.44,26.44,39.44z"
      />
      <g>
        <defs>
          <path
            id="SVGID_1_"
            d="M26.44,39.44c-7.18,0-13-5.82-13-13s5.82-13,13-13s13,5.82,13,13h8c0-11.6-9.4-21-21-21s-21,9.4-21,21
				s9.4,21,21,21V39.44z"
          />
        </defs>
        <clipPath id="SVGID_00000080927153760372526660000006426525558884123316_">
          <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
        </clipPath>
        <g
          style={{
            clipPath:
              'url(#SVGID_00000080927153760372526660000006426525558884123316_)'
          }}
        >
          <g>
            <defs>
              <rect
                id="SVGID_00000023990837409606865850000005658303434822120612_"
                x="0.44"
                y="0.44"
                width="52"
                height="52"
              />
            </defs>
            <clipPath id="SVGID_00000102520476847146863300000017491236338198908080_">
              <use
                xlinkHref="#SVGID_00000023990837409606865850000005658303434822120612_"
                style={{ overflow: 'visible' }}
              />
            </clipPath>
            <g
              style={{
                clipPath:
                  'url(#SVGID_00000102520476847146863300000017491236338198908080_)'
              }}
            >
              <image
                style={{ overflow: 'visible' }}
                width="110"
                height="110"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAABuCAYAAADGWyb7AAAACXBIWXMAABcRAAAXEQHKJvM/AAAV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"
                transform="matrix(0.48 0 0 0.48 0 0)"
              ></image>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Spin;
